import { t } from '@avalara/bat-apps-shared/i18n';
import { useSelector } from 'react-redux';
import { useHistory, useLocation } from 'react-router-dom';

import { checkIsAuthenticated } from '../../../../lib/helpers';
import { isEsbFormOneIncomplete } from '../../../../lib/shared-signup';
import { selectState } from '../../../../selectors';
import { getEsbConfig } from '../../../../selectors/esb';
import SettingUp from '../../../shared/setting-up';
import ConfirmCompanyDetails from './confirm-company-details';
import EditCompanyDetailsForm from './edit-company-details';

const CompanyInfo = () => {
  const history = useHistory();
  const location = useLocation();

  const {
    esb: { esbPartner, esbPath },
    sharedSignup,
  } = useSelector(selectState);

  const isCompanyInfoComplete = sharedSignup.isPrepopulated || !isEsbFormOneIncomplete(sharedSignup);
  const esbConfig = useSelector(getEsbConfig);

  if (checkIsAuthenticated()) return <SettingUp />;
  if (!esbPartner) return null;
  // Skip the payment page redirect if partner is Avalara Included
  const redirectPath = `/${esbPath}/${esbPartner}/${!esbConfig || esbConfig.isPaymentRequired ? 'payment-method' : 'create-login'}`;

  return (
    <>
      {sharedSignup.isPrepopulated && !!esbConfig ? <ConfirmCompanyDetails /> : <EditCompanyDetailsForm />}

      <hr className='pad-bottom-lg margin-top-lg' />

      <button
        type='button'
        className='primary'
        data-ref='esb.start-trial-button'
        disabled={!isCompanyInfoComplete}
        onClick={() =>
          history.push({
            pathname: redirectPath,
            search: location.search,
          })
        }
      >
        {t('client.buttons.next')}
      </button>
    </>
  );
};

export default CompanyInfo;
